// D-264 §1 — pure model of the customers-page "סוג התקשרות" filter.
// Every type appears once: the old "active project / service contract / hour
// bank" switches duplicated three of the five types and were removed. Old
// links that carry them (?ep=1 &sc=1 &hb=1) are folded into the matching type,
// so the link still finds those customers.

export const FILTER_WORK_TYPES = [
  'project', 'development', 'service_contract', 'hour_bank', 'service_without_contract',
] as const;

export type FilterWorkType = (typeof FILTER_WORK_TYPES)[number];

/**
 * Types picked in the URL plus the legacy switch flags. A legacy flag means
 * "an ACTIVE engagement of that type", so it adds the type AND turns on the
 * single "active only" switch (which then applies to all chosen types).
 * Canonical order, no repeats.
 */
export function foldLegacyEngagementFlags(
  types: readonly string[],
  legacy: { activeProject?: boolean; serviceContract?: boolean; hourBank?: boolean },
  activeOnly = false,
): { types: FilterWorkType[]; activeOnly: boolean } {
  const picked = new Set<string>(types);
  if (legacy.activeProject) picked.add('project');
  if (legacy.serviceContract) picked.add('service_contract');
  if (legacy.hourBank) picked.add('hour_bank');
  const anyLegacy = !!(legacy.activeProject || legacy.serviceContract || legacy.hourBank);
  const list = FILTER_WORK_TYPES.filter((ty) => picked.has(ty));
  return { types: list, activeOnly: list.length > 0 && (activeOnly || anyLegacy) };
}

/** Engagement statuses the type filter matches: open ones, or only active when the switch is on. */
export const OPEN_FILTER_STATUSES = ['planning', 'active', 'on_hold'] as const;
export function filterStatuses(activeOnly: boolean): readonly string[] {
  return activeOnly ? ['active'] : OPEN_FILTER_STATUSES;
}
